import { Button } from "@/components/ui/button";
import { openCreateNewsAlertModal } from "@/store/news-alerts/news-alerts.actions";
import { CircleIcon } from "@phosphor-icons/react";

const NewsAlertsEmptyView = () => {
  return (
    <div className="flex flex-col p-2 gap-4 max-h-[calc(100vh-8rem)]">
      <div className="relative flex items-center justify-center mb-8">
        <CircleIcon
          size={168}
          className="translate-x-[125%] text-violet-300"
          weight="thin"
        />
        <CircleIcon
          size={168}
          className="translate-x-0 text-violet-500"
          weight="thin"
        />
        <CircleIcon
          size={168}
          className="translate-x-[-125%] text-violet-700"
          weight="thin"
        />
      </div>
      <div className="flex flex-col items-center justify-center gap-2">
        <h1 className="text-2xl font-serif">
          Looks like there’s no alerts yet!
        </h1>
        <p className="text-slate-600 text-sm">
          Create a daily alert to get started.
        </p>
      </div>
      <div className="w-full flex justify-center">
        <Button onClick={openCreateNewsAlertModal}>Create Alert</Button>
      </div>
    </div>
  );
};

export default NewsAlertsEmptyView;
